import React, { Component } from 'react';
import PageHeading from '../../components/PageHeading';
import { LazyPage } from '../../components/LazyPage';
import { ListGroup, ListGroupItem, Media } from 'reactstrap';
import './styles.scss';
import Dot from '../../components/Dot';

export default class MyDealersPage extends Component {
  dealers = [
    {
      img: 'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/9e/e9/30/9ee9301b-0b50-573d-1d8b-e21de0f4de0c/source/512x512bb.jpg',
      name: 'DropSpot'
    },
    {
      img: 'https://images.vexels.com/media/users/3/146522/isolated/lists/beb98111b5c2e7c7b8a57cf9410dfa85-sealed-box-with-package-signs.png',
      name: 'Very Well'
    },
    {
      img: 'https://pbs.twimg.com/profile_images/684644009273196544/vl-PArb9_400x400.png',
      name: 'Drop me now!'
    }
  ];

  render() {
    return (
      <LazyPage>
        <PageHeading>Мои поставщики</PageHeading>

        <ListGroup className="dealer-list" style={{ width: '400px' }}>
          {this.dealers.map(dealer => {
            return <ListGroupItem key={dealer.name}>
              <Media>
                <Media left href="#">
                  <Media object src={dealer.img} alt=""/>
                </Media>
                <Media body>
                  <Media heading>{dealer.name}</Media>
                  <a className="text-secondary" href="">Заказы</a><Dot/><a className="text-secondary" href="">Выплаты</a><Dot/><a className="text-secondary" href="">Товары</a>
                </Media>
              </Media>
            </ListGroupItem>;
          })}
        </ListGroup>
      </LazyPage>
    );
  }
}
